<div class="mt-2">
  <button
    type="button"
    class="inline-flex flex-row items-center gap-1.5 h-[26px] px-2.5 rounded-full bg-surface-0 dark:bg-surface-800 border border-solid border-surface-200 dark:border-surface-700 text-xs font-semibold text-surface-700 dark:text-surface-200 cursor-pointer"
    [attr.aria-expanded]="expanded()"
    [attr.aria-controls]="listId"
    (click)="toggle()"
    data-e2e="ai-sources-toggle"
  >
    <i class="mi2-visibility-on text-[13px] text-primary"></i>
    <span>{{ 'cl_chat.aiSourcesCount' | translate: { count: sources().length } }}</span>
    <i
      class="mi2-arrow-down text-[11px] transition-transform duration-200 ease-in-out"
      [ngClass]="{ 'rotate-180': expanded() }"
    ></i>
  </button>
  @if (expanded()) {
    <div
      [id]="listId"
      class="mt-1.5 rounded-lg border border-solid border-surface-200 dark:border-surface-700 bg-surface-0 dark:bg-surface-900 px-3 py-1 max-w-full"
      data-e2e="ai-sources-list"
    >
      @for (source of sources(); track source.title + $index; let last = $last) {
        <div class="py-1.5" [ngClass]="{ 'border-b border-solid border-surface-100 dark:border-surface-800': !last }">
          <div class="flex items-baseline gap-1.5">
            <div class="text-xs font-bold text-surface-950 dark:text-surface-0">{{ source.title }}</div>
            @if (matchPercent(source) !== null) {
              <div class="text-[10px] text-surface-500 dark:text-surface-400" data-e2e="ai-source-match">
                {{ 'cl_chat.aiSourceMatch' | translate: { score: matchPercent(source) } }}
              </div>
            }
          </div>
          <div class="text-xs text-surface-600 dark:text-surface-300 truncate">{{ excerptFor(source) }}</div>
        </div>
      }
    </div>
  }
</div>
